import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { COLOR, FONT_FAMILIES } from 'config';
import media from 'utils/media';

import Card from './Card';
import { ImageGraphicCardContainer } from './ImageCard';
import Title from './Title';
import image from '../images/Mobile_Wallet_graphic_2.png';
import Button from './Button';

const StyledText = styled.ul`
  font-family: ${FONT_FAMILIES.sans};
  a {
    color: ${props => (props.linkColor ? props.linkColor : 'inherit')};
  }
  font-size: 16px;
  line-height:2.35rem !important;
  margin-bottom:0;
`;

const StyledButton = styled(Button)`
  background-color:${COLOR.base};
  flex: 1 !important;
  border-radius:5px;
  padding: 12px 24px;
  padding-bottom: 13px;
  margin-top: 14px;
  margin-right: 8px !important;
  color: white;
  font-size: 12px !important;
  line-height: 2.2 !important;
  &:hover{
    background-color:${COLOR.base};
}`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  ${media.sm.css`
  flex-direction: row;
  `}
`;


const Accessible = () => {
  const icon = (<ImageGraphicCardContainer
    image={image}
    height="560px"
    width="480"
    backgroundColor={COLOR.base}
    backgroundSize={'450px'}
    backgroundImageOnBottom
  />);

  return (
    <Card image={icon} mb={'3rem'}>
      <Title id="landing.mobileWallets.accessible.title" />
      <StyledText>
        <FormattedHTMLMessage id="landing.mobileWallets.accessible.description" />
      </StyledText>
      <Flex>
        <StyledButton to="https://apps.apple.com/gb/app/skycoin/id1439949089" width="100%">
          <FormattedMessage id="landing.mobileWallets.accessible.button" />
        </StyledButton>
        <StyledButton to="" width="100%" backgroundColor={COLOR.dark}>
          <FormattedMessage id="landing.mobileWallets.accessible.button2" />
        </StyledButton>
      </Flex>
    </Card>
  );
};

export default Accessible;

/* <StyledButton to="https://play.google.com/store/apps/details?id=com.skycoin.wallet" width="100%" backgroundColor={COLOR.dark}> */



// WEBPACK FOOTER //
// ./src/components/MobileWalletsLanding/components/Accessible.js